import type { PlanType } from '~/resources/graphql/graphql'

export enum StorefrontIconGlyph {
    'SHOPPING_BAG' = 'SHOPPING_BAG',
    'MOUNTAIN' = 'MOUNTAIN',
    'PERSON' = 'PERSON'
}

export type StorefrontIcon = {
    __typename: 'StorefrontIcon'
    url: string | null
    glyph: StorefrontIconGlyph | null
}

export type StorefrontCatalogScalar = {
    __typename: 'StorefrontCatalog'
    slug: string
    showInLinkBar: boolean
    icon: StorefrontIcon | null
    title: string
    metaDescription: string
    body: string
    shortSummaryMarkup: string
    children: (
        | StorefrontCalendarScalar
        | StorefrontPlanScalar
        | StorefrontCatalogScalar
    )[]
}

export type StorefrontCalendarScalar = {
    __typename: 'StorefrontCalendar'
    guid: string
    slug: string
    showInLinkBar: boolean
    icon: StorefrontIcon | null
    title: string
    metaDescription: string
    body: string
    shortSummaryMarkup: string
    children: StorefrontCalendarGroupScalar[]
}

export type StorefrontCalendarGroupScalar = {
    __typename: 'StorefrontCalendarGroup'
    slug: string
    showInLinkBar: boolean
    title: string
    body: string
    displayChildren: boolean
    children: StorefrontPlanScalar[]
}

export type StorefrontPlanScalar = {
    __typename: 'StorefrontPlan'
    slug: string
    showInLinkBar: boolean
    icon: StorefrontIcon | null
    title: string
    subtitle: string
    planId: string
    planType: PlanType
}

export type StorefrontNode =
    | StorefrontCatalogScalar
    | StorefrontCalendarScalar
    | StorefrontCalendarGroupScalar
    | StorefrontPlanScalar
